// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class AsyncJobFailedObject {
  readonly objectId: string;
  readonly reason: string | null;

  constructor(data: { [key: string]: any } = {}) {
    this.objectId = data.objectId === undefined ? NIL_UUID : data.objectId;
    this.reason = data.reason === undefined ? null : data.reason;
  }

  static zero(): AsyncJobFailedObject {
    const zeroValues: ExcludeMethodsDeep<AsyncJobFailedObject> = {
      objectId: NIL_UUID,
      reason: null,
    };
    return new AsyncJobFailedObject(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type AsyncJobFailedObjectWireFormat = {
  objectId: string;
  reason: string | null;
};

type NewAsyncJobFailedObjectProps = PartialDeep<AsyncJobFailedObject, { recurseIntoArrays: true }>;
export const NewAsyncJobFailedObject: (
  props: NewAsyncJobFailedObjectProps,
) => AsyncJobFailedObject = (props) => new AsyncJobFailedObject(props);

type NewAsyncJobFailedObjectFromWireFormatProps = PartialDeep<
  AsyncJobFailedObjectWireFormat,
  { recurseIntoArrays: true }
>;
export const NewAsyncJobFailedObjectFromWireFormat: (
  props: NewAsyncJobFailedObjectFromWireFormatProps,
) => AsyncJobFailedObject = (props) => new AsyncJobFailedObject(props);
